/**
 * EcosystemOrgsBlock: `ecosystem-orgs` DYNAMIC content block.
 *
 * data: { limit? }
 *
 * Fetches a random cross-section of approved organizations and delegates
 * rendering to the shared OrgCarousel component. The selection refreshes on
 * each page load — no curation required.
 *
 * The `limit` config (default 9) controls the total number of orgs fetched;
 * the carousel pages through them 3 at a time.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Container, Spinner } from 'react-bootstrap';

import { useOrganizationApi } from '@/shared/services/organizationApi';
import { useEcosystem } from '@/shared/contexts/EcosystemContext';

import OrgCarousel from './OrgCarousel';
import useOrgFetcher from './useOrgFetcher';

export default function EcosystemOrgsBlock({ data }) {
    const { limit = 9 } = data || {};
    const { ecosystem } = useEcosystem();
    const ecosystemName = ecosystem?.name || 'the ecosystem';

    const orgApi = useOrganizationApi();
    const { organizations, loading } = useOrgFetcher(
        () => orgApi.fetchFeaturedOrganizations(limit),
        limit
    );

    if (loading) {
        return (
            <section className="ecosystem-orgs-block py-5">
                <Container className="text-center">
                    <Spinner animation="border" variant="primary" size="sm" />
                </Container>
            </section>
        );
    }

    if (organizations.length === 0) {
        return null;
    }

    return (
        <OrgCarousel
            key={limit}
            organizations={organizations}
            heading="Organizations in this Ecosystem"
            subtitle={`Discover organizations in ${ecosystemName}`}
            sectionClassName="ecosystem-orgs-block"
        />
    );
}

EcosystemOrgsBlock.propTypes = {
    data: PropTypes.shape({
        limit: PropTypes.number,
    }),
};

EcosystemOrgsBlock.defaultProps = {
    data: {},
};
